// extracted by mini-css-extract-plugin
export default {"primary":"var(--primary)","breakpoint-xxs":"360px","breakpoint-xs":"540px","breakpoint-s":"900px","breakpoint-m":"1024px","breakpoint-l":"1200px","breakpoint-xl":"1400px"};